import { gl } from '../../Engine';
import { Environment } from '../../data/Environment';
import { ImageObject } from '../../data/image/ImageObject';
import { TextureView } from '../TextureView';
import { Layer } from './Layer';
import { LayerBit } from './LayerBit';
import { FilterClass, ImageFilter } from './filters/Filter';

/**
 * {@link ImageLayer} provides common properties of {@link Layer Layers} containing {@link ImageObject}data.\
 * {@link ImageLayer ImageLayers} have {@link internalFormat} of type {@link gl.RGBA8} and\
 * {@link format} of type {@link gl.RGBA}.
 */
export class ImageLayer extends Layer<ImageObject> {
    /**
     * ImageLayer constructor
     * @param parent {@link TextureView} on which this {@link ImageLayer} resides.
     */
    public constructor(parent: TextureView, env: Environment) {
        super(parent, env);
    }

    /**
     * Method to get the default {@link FilterClass} used by {@link ImageLayer ImageLayers}.
     * @returns The {@link ImageFilter}, which renders the {@link ImageObject}data without any {@link ImageFilter.postProcessing postprocessing effects}.
     */
    public getDefaultFilter(): FilterClass<ImageObject> {
        return ImageFilter;
    }

    /**
     * The internal format of {@link ImageLayer}s {@link Layer._texture texture}.\
     * {@link ImageLayer ImageLayers} use this format to support colors.\
     * The number of {@link TextureView Views} & {@link Layer Layers} is so small
     * that the memory difference between 8bit and 32bit view textures does not make much difference.
     */
    public get internalFormat(): number {
        return gl.RGBA8;
    }

    /**
     * The format of the {@link Layer._texture texture} this {@link Layer} defines.
     */
    public get format(): number {
        return gl.RGBA;
    }

    /**
     * The {@link LayerBit.IMAGE_LAYER_BIT}
     */
    public get layerBit(): number {
        return LayerBit.IMAGE_LAYER_BIT;
    }

    /**
     * Method to retrieve the {@link ImageObject Images} currently loaded in the {@link Environment}.
     * @param environment The {@link Environment} from which the {@link ImageObject ImageObjects} are loaded.
     * @returns An {@link Array} of all the {@link ImageObject ImageObjects} currently loaded in the {@link environment}.
     */
    public getTargets(environment: Environment): ImageObject[] {
        const images: ImageObject[] = [];
        if (environment.image) {
            images.push(environment.image);
        }
        if (environment.secondaryImage) {
            images.push(environment.secondaryImage);
        }
        return images;
    }
}
